import React from "react";


// this is the equivalent to the createStore method of Redux


const ModalContext = React.createContext();


// creating Provider and Consumer and exporting them.

export const ModalProvider = ModalContext.Provider

export const ModalConsumer = ModalContext.Consumer

export function withUserContext(Component) {
    return function WrappedWithContext(props) {
        return (
            <ModalContext.Consumer>
                {({ show,setShow,loaded,setLoaded ,setShowSchedule ,showSchedule, redirect, setRedirect }) => {
                    return (
                        <Component
                            {...props}
                            show={show}
                            setShow={setShow}
                            loaded={loaded}
                            setLoaded={setLoaded}
                            showSchedule={showSchedule}
                            setShowSchedule={setShowSchedule}
                            redirect = {redirect}
                            setRedirect = {setRedirect}
                        />
                    );
                }}
            </ModalContext.Consumer>
        );
    };
}

export default ModalContext;